module.exports = __webpack_public_path__ + "img/tertiary_10x1.a7af6bc7.svg";